import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Styles from "./Filter.module.css";
import { IoSearchSharp } from "react-icons/io5";
// import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { filter, orderBy } from "lodash";
import moment from "moment";
import { MultiSelect } from "react-multi-select-component";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
Modal.setAppElement("#root");
function Filter({
    isOpen,
    setIsOpen,
    data,
    setFilters,
    filters,
    setEquipmentFilters,
    internalFilter,
    setInteralfilter,
    searchString,
}) {
    const [Active, setActive] = useState(1);
    const [options, setOptions] = useState([]);
    // console.log(onchange);
    const [value, onChange] = useState([null, null]);
    const [value1, onChange1] = useState([null, null]);
    const [selected, setSelected] = useState([]);

    const FilterButtons = [
        {
            name: "Place ID",
            id: 1,
        },
        {
            name: "Status",
            id: 2,
        },
        {
            name: "Domain",
            id: 3,
        },
        {
            name: "Rating",
            id: 4,
        },
        {
            name: "Created At",
            id: 5,
        },
    ];
    useEffect(() => {
        if (Active === 1) {
            if (filters.length > 0) {
                setInteralfilter(filters);
                let selectedFilter = filters.filter(
                    (item) => item.FilterName == "Place ID"
                );
                if (selectedFilter?.length > 0) {
                    setSelected(
                        selectedFilter[0]?.keys?.map((item) => ({
                            label: item,
                            value: item,
                        }))
                    );
                }
            }
            setOptions(
                [...new Set(data.flatMap((item) => item.placedIdArray))]?.map(
                    (item) => ({
                        label: String(item),
                        value: String(item),
                    })
                )
            );
        }
        if (Active === 2) {
            setOptions([
                {
                    label: "Active",
                    value: 1,
                },
                {
                    label: "Locked",
                    value: 2,
                },
            ]);
        }

        if (Active == 3) {
            setOptions(
                [
                    ...new Set(
                        data?.map(
                            (item) => `${String(item.emailId).split("@")[1]}`
                        )
                    ),
                ]?.map((item) => ({
                    label: item,
                    value: item,
                }))
            );
        }
        if (Active == 4) {
            setOptions(
                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((item) => ({
                    label: item,
                    value: item,
                }))
            );
        }
    }, [Active]);
    const ActiveHandler = (e) => {
        const id = Number(e.currentTarget.getAttribute("id"));
        if (id === 1) {
            let selectedFilter = internalFilter.filter(
                (item) => item.FilterName == "Place ID"
            );
            if (selectedFilter?.length > 0) {
                setSelected(
                    selectedFilter[0]?.keys?.map((item) => ({
                        label: item,
                        value: item,
                    }))
                );
            } else {
                setSelected([]);
            }
        }
        if (id === 2) {
            let selectedFilter = internalFilter.filter(
                (item) => item.FilterName == "Status"
            );
            if (selectedFilter?.length > 0) {
                setSelected(
                    selectedFilter[0]?.keys?.map((item) => ({
                        label: item,
                        value: item,
                    }))
                );
            } else {
                setSelected([]);
            }
        }
        if (id === 4) {
            let selectedFilter = internalFilter.filter(
                (item) => item.FilterName == "Rating"
            );
            if (selectedFilter?.length > 0) {
                setSelected(
                    selectedFilter[0]?.keys?.map((item) => ({
                        label: item,
                        value: item,
                    }))
                );
            } else {
                setSelected([]);
            }
        }
        if (id === 3) {
            let selectedFilter = internalFilter.filter(
                (item) => item.FilterName == "Domain"
            );
            if (selectedFilter?.length > 0) {
                setSelected(
                    selectedFilter[0]?.keys?.map((item) => ({
                        label: item,
                        value: item,
                    }))
                );
            } else {
                setSelected([]);
            }
        }
        if (id == 5) {
            let selectedFilter = internalFilter.filter(
                (item) => item.FilterName == "Created At"
            );
            console.log(selectedFilter);
            if (selectedFilter.length > 0) {
                onChange([
                    new Date(selectedFilter[0].keys[0]),
                    new Date(selectedFilter[0].keys[1]),
                ]);
            }
        }

        setActive(Number(id));
    };
    const SelectHandler = (keys) => {
        setSelected(keys);
        if (Active == 1) {
            let allFilters = [...internalFilter];
            let filteredData = allFilters.filter(
                (item) => item.FilterName != "Place ID"
            );
            if (keys.length > 0) {
                setInteralfilter((prev) => [
                    ...filteredData,
                    {
                        FilterName: "Place ID",
                        Bkey: "placeIds",
                        keys: keys?.map((item) => item.value),
                        label: keys?.map((item) => item.label),
                    },
                ]);
            } else {
                setInteralfilter(filteredData);
            }
        }
        if (Active == 2) {
            let allFilters = [...internalFilter];
            let filteredData = allFilters.filter(
                (item) => item.FilterName != "Status"
            );
            if (keys.length > 0) {
                setInteralfilter((prev) => [
                    ...filteredData,
                    {
                        FilterName: "Status",
                        Bkey: "status",
                        keys: keys?.map((item) => item.value),
                        label: keys?.map((item) => item.label),
                    },
                ]);
            } else {
                setInteralfilter(filteredData);
            }
        }
        if (Active == 4) {
            let allFilters = [...internalFilter];
            let filteredData = allFilters.filter(
                (item) => item.FilterName != "Rating"
            );
            if (keys.length > 0) {
                setInteralfilter((prev) => [
                    ...filteredData,
                    {
                        FilterName: "Rating",
                        Bkey: "rating",
                        keys: keys?.map((item) => item.value),
                        label: keys?.map((item) => item.label),
                    },
                ]);
            } else {
                setInteralfilter(filteredData);
            }
        }
        if (Active == 3) {
            let allFilters = [...internalFilter];
            let filteredData = allFilters.filter(
                (item) => item.FilterName != "Domain"
            );
            if (keys.length > 0) {
                setInteralfilter((prev) => [
                    ...filteredData,
                    {
                        FilterName: "Domain",
                        Bkey: "emailId",
                        keys: keys?.map((item) => item.value),
                        label: keys?.map((item) => item.label),
                    },
                ]);
            } else {
                setInteralfilter(filteredData);
            }
        }
    };
    const clearhandler = () => {
        setFilters([]);
        setInteralfilter([]);
        localStorage.removeItem("UserFilter");
        setEquipmentFilters(
            orderBy([...data], (item) => item.createdAt, "desc")
        );
        setSelected([]);
        setIsOpen(false);
    };
    // Define a function to filter objects based on the specified Bkey
    function filterObjectsByBkey(objects, filter) {
        console.log(objects, filter);
        const { Bkey, keys } = filter;
        if (Bkey == "emailId") {
            return objects.filter((obj) => {
                return keys.some((domain) => obj[Bkey].includes(domain));
            });
        }
        if (Bkey == "placeIds") {
            return objects.filter((item) =>
                item.placedIdArray.some((id) => keys.includes(String(id)))
            );
        }
        return objects.filter((obj) => keys.includes(obj[Bkey]));
    }
    const ApplyHandler = () => {
        let filteredResults = data;

        let Internal = internalFilter;
        for (const filter of internalFilter) {
            filteredResults = filterObjectsByBkey(filteredResults, filter);
            console.log(filteredResults);
        }
        if (value[0] != null && value[1] != null) {
            let StartDate = new Date(value[0]);
            let EndDate = new Date(value[1]);
            StartDate.setHours(0, 0, 0, 0);
            EndDate.setHours(0, 0, 0, 0);
            const filteredDates = filter(filteredResults, (item) => {
                const currentDate = new Date(item.createdAt);
                currentDate.setHours(0, 0, 0, 0);
                return currentDate >= StartDate && currentDate <= EndDate;
            });
            filteredResults = [...filteredDates];

            Internal = internalFilter.filter(
                (item) => item.FilterName != "Created At"
            );
            Internal = [
                ...Internal,
                {
                    FilterName: "Created At",
                    Bkey: "createdAt",
                    keys: [
                        moment(value[0]).format("YYYY MMM DD"),
                        moment(value[1]).format("YYYY MMM DD"),
                    ],
                    label: [
                        moment(value[0]).format("YYYY MMM DD"),
                        moment(value[1]).format("YYYY MMM DD"),
                    ],
                },
            ];
        }
        if (searchString.length > 0) {
            filteredResults = filteredResults.filter((user) =>
                user.emailId
                    .toLowerCase()
                    .includes(String(searchString).toLowerCase())
            );
        }
        // console.log(filteredResults);
        setEquipmentFilters(
            orderBy([...filteredResults], (item) => item.createdAt, "desc")
        );
        console.log([...filteredResults]);
        setIsOpen(false);
        setFilters([...Internal]);
        localStorage.setItem("UserFilter", JSON.stringify([...Internal]));
    };
    return (
        <Modal
            isOpen={isOpen}
            contentLabel="Modal"
            onRequestClose={() => setIsOpen(false)}
            className={Styles["modal"]}
            overlayClassName={Styles["overlay"]}>
            <div className={Styles["Container"]}>
                <div className={Styles["filter"]}>
                    <div className={Styles["left_filter"]}>
                        <h3>Filter</h3>
                        {FilterButtons.map((item) => (
                            <button
                                id={item.id}
                                onClick={ActiveHandler}
                                className={
                                    Active == item.id ? Styles["button"] : ""
                                }>
                                {item.name}
                            </button>
                        ))}
                    </div>
                    <div className={Styles["filter_input"]}>
                        {Active != 5 && (
                            <MultiSelect
                                options={options}
                                value={selected}
                                onChange={SelectHandler}
                                labelledBy={"Select"}
                                className={Styles["react-mulit-select"]}
                            />
                        )}
                        {Active != 5 && (
                            <IoSearchSharp className={Styles["icon"]} />
                        )}
                        {Active === 5 && (
                            <DateRangePicker
                                onChange={onChange}
                                value={value}
                            />
                        )}
                        <div className={"Filters_wrapper"}>
                            {filters.map((item) => (
                                <div className={"Filters"}>
                                    <h3>{item?.FilterName}</h3>

                                    <p>{item?.keys?.join(",")}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={Styles["clear"]}>
                    <button onClick={clearhandler}>Clear</button>
                    <button onClick={ApplyHandler}>Apply</button>
                </div>
            </div>
        </Modal>
    );
}

export default Filter;
